if(!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', class SwiperSlider extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    get slidesQuantity () {
      return Number(this.dataset.slides);
    }
  
    get pagiantionType () {
      return this.dataset.paginationType;
    }
  
    get showNavigation() {
      return this.dataset.navigation === 'true' ? true : false;
    }

    get autoPlay() {
      return this.dataset.autoplay === 'true' ? true : false;
    }

    get autoPlayDelay() {
      return this.dataset.autoplayDelay ? Number(this.dataset.autoplayDelay) : 5000;
    }

    get loop() {
      return this.dataset.loop === 'true' ? true : false;
    }

    get slidesPerViewMobile() {
      return this.dataset.slidesPerViewMobile ? Number(this.dataset.slidesPerViewMobile) : 2;
    }

    get slidesPerViewTablet() {
      return this.dataset.slidesPerViewTablet ? Number(this.dataset.slidesPerViewTablet) : 3;
    }

    get grabCursor() {
      return this.dataset.grabCursor === 'true' ? true : false; // default false
    }

    get centeredSlides() {
      return this.dataset.centeredSlides === 'true' ? true : false; // default false
    }

    get cssMode() {
      return this.dataset.cssMode === 'false' ? false : true; // default true
    }

    get mobileDisabled() {
      return this.dataset.mobileDisabled === 'true';
    }
  
    initSlider() {
      const slider = this.querySelector('.swiper');
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');

      if (slider) {
        if (window.innerWidth < 750 && this.mobileDisabled) return;

        const options = {
          navigation: {
            nextEl,
            prevEl,
          },
          slidesPerView: this.slidesPerViewMobile,
          spaceBetween: 4,
          loop: this.loop,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
          },
          breakpoints: {
            750: {
              slidesPerView: this.slidesPerViewTablet,
            },
            990: {
              slidesPerView: this.slidesQuantity,
              spaceBetween: 8,
              cssMode: true,
            }
          }
        }

        const swiper = new Swiper(slider, options);

        if (this.slidesQuantity < 4 && window.innerWidth >= 990) {
          swiper.destroy();
        }
      }
    }
  })
}